angular.module('miq.util', []);
